export default {"src":"/_next/static/media/racoon_sad.e0ac6615.svg","height":302,"width":309};